import { Alert } from '@src/controls';
import { authSelectors } from '@src/modules/auth';
import { getCurrentPageName } from '@src/utils/url';
import { useSelector } from '@src/utils/hooks';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

const PLATFORM_OWNERSHIP = 'Owned by Team / Platform';
const PRE_PURCHASE_OWNERSHIP = 'Owned by Consumer / Pre-Purchase';
const POST_PURCHASE_OWNERSHIP = 'Owned by Consumer / Post-Purchase';

const ownershipLabelByPage: { [pageName: string]: string } = {
  users: PLATFORM_OWNERSHIP,
  groups: PLATFORM_OWNERSHIP,
  merchants: PLATFORM_OWNERSHIP,

  features: PRE_PURCHASE_OWNERSHIP,
  regions: PRE_PURCHASE_OWNERSHIP,
  warehouses: PRE_PURCHASE_OWNERSHIP,
  experiments: PRE_PURCHASE_OWNERSHIP,
  'checkout-widget': PRE_PURCHASE_OWNERSHIP,
  'checkout-daily': PRE_PURCHASE_OWNERSHIP,
  'upsell-features': PRE_PURCHASE_OWNERSHIP,
  'upsell-widget': PRE_PURCHASE_OWNERSHIP,
  'faq-widget-features': PRE_PURCHASE_OWNERSHIP,
  'faq-widget': PRE_PURCHASE_OWNERSHIP,
  'product-page-features': PRE_PURCHASE_OWNERSHIP,
  'product-page-widget': PRE_PURCHASE_OWNERSHIP,
  'receipt-features': PRE_PURCHASE_OWNERSHIP,
  'receipt-widget': PRE_PURCHASE_OWNERSHIP,
  sessionEvents: PRE_PURCHASE_OWNERSHIP,

  'product-mappings': POST_PURCHASE_OWNERSHIP,
  'tracking-numbers': POST_PURCHASE_OWNERSHIP,
  notifications: POST_PURCHASE_OWNERSHIP,
  'tracking-playground': POST_PURCHASE_OWNERSHIP,
  'tracking-widget': POST_PURCHASE_OWNERSHIP,
  'tracking-daily': POST_PURCHASE_OWNERSHIP,
};

const pagesWithFixedStatusBar = new Set([
  'features',
  'regions',
  'warehouses',
  'product-mappings',
  'upsell-features',
  'faq-widget-features',
  'faq-widget',
  'product-page-features',
  'receipt-features',
]);

const pageBannerStyleByPage: { [pageName: string]: React.CSSProperties } = {
  sessionEvents: {
    marginTop: '24px',
    marginLeft: '24px',
    marginRight: '24px',
  },
};

export const SectionOwnershipBanner: React.FunctionComponent = () => {
  const { pathname } = useLocation();
  const isIngridEmployee = useSelector(authSelectors.isIngridEmployee);

  if (!isIngridEmployee) {
    return null;
  }

  const pageName = getCurrentPageName(pathname);
  const ownershipLabel = ownershipLabelByPage[pageName];
  if (!ownershipLabel) {
    return null;
  }

  return (
    <Alert
      message={ownershipLabel}
      style={{
        marginBottom: '16px',
        marginTop: pagesWithFixedStatusBar.has(pageName) ? '48px' : undefined,
        ...pageBannerStyleByPage[pageName],
      }}
      type="info"
      showIcon
    />
  );
};
